import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

import {
  ModalDismissReasons,
  NgbActiveModal,
  NgbModal,
} from "@ng-bootstrap/ng-bootstrap";
import { GenericModalOptions } from "../../../form/generic-app-modal/generic-modal.component";

@Component({
  selector: "password-reset-modal",
  templateUrl: "./password-reset-modal.component.html",
  styleUrls: ["./password-reset-modal.component.scss"],
})
export class PasswordResetModalComponent implements OnInit {
  @Output("result") public modalResult: EventEmitter<any> =
    new EventEmitter<boolean>();
  public modalText: string = "הקלידו את הסיסמה החדשה";
  public modalHeader: string = "החלפת סיסמה";
  public approveOption?: string = "אישור";
  public cancelOption?: string = "ביטול";
  public data: any = null;
  public customTextStyle: { [p: string]: string } = {};

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal
  ) {}

  @Input("modalOptions") set modalOptions(options: GenericModalOptions) {
    this.modalText = options.modalText;
    this.modalHeader = options.modalHeader;
    this.approveOption = options.approveOption || this.approveOption;
    this.cancelOption = options.approveOption || this.cancelOption;
    // tslint:disable-next-line:no-object-literal-type-assertion
    this.customTextStyle = options.customTextStyle || {
      "white-space": "pre-wrap",
    };
    if (options.onlyApprove) {
      this.cancelOption = "";
    }
  }

  public ngOnInit(): void {}

  public modalClose(result: string) {
    this.activeModal.close(result);
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/password-reset-modal/password-reset-modal.component.ts